import React from "react";
import { ConfirmDialog } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordStatus } from "../../../../../../../common/types/FileRecordStatus";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";

interface QcStatusDialogProps {
    isOpen: boolean;
    onClose: () => void;
}

export const QcStatusDialog = ({ isOpen, onClose }: QcStatusDialogProps): JSX.Element => {
    const { changeFileRecordToQc } = useFileRecordApi();

    const { fileRecordDetails, setStatus } = useFileRecordDetailsState();

    const handleConfirmation = async () => {
        await changeFileRecordToQc({ fileRecordId: fileRecordDetails.id });

        setStatus(FileRecordStatus.Qc);

        onClose();
    };

    return (
        <ConfirmDialog
            title="Change status to Qc"
            text="Are you sure you want to update given file record to Qc?"
            hidden={!isOpen}
            confirm={{ onClick: handleConfirmation }}
            cancel={{ onClick: onClose }}
        />
    );
};
